import React from 'react';
import PropTypes from 'prop-types';
import UploadPanel from './uploadPanel';
import { SidePanel } from 'front-onceforall-core';
import { authenticationService } from '../../../../services/authentication/AuthenticationService';
import { requestService } from '../../../../services/request/RequestService';
import { openOrSaveFile } from '../../../../utils/http';
import DocumentView from './DocumentView';
import { DOCUMENT_CATEGORY, DOCUMENT_STATUS, RFA_STATUS } from '../../../../utils/constant';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export const DocumentContainer = props => {
  const [disabledUploadReason, setDisabledUploadReason] = React.useState(null);
  const [disabledUpdateReason, setDisabledUpdateReason] = React.useState(null);
  const [isPanelOpen, setIsPanelOpen] = React.useState(false);
  let triggerClosePanel = () => {};
  const handleDocumentUploaded = newDocument => {
    triggerClosePanel();
    props.onDocumentUpload(newDocument);
  };
  const downloadDocument = id => {
    authenticationService.authRedirect(requestService.downloadDocument(id)).then(authUrl => {
      openOrSaveFile(authUrl);
    });
  };
  const handleUploadDocument = () => {
    setIsPanelOpen(true);
  };
  const handleDownloadDocument = () => {
    downloadDocument(props.document.id);
  };
  const getDisabledUploadReason = () => {
    // Conditions for disabling the Upload button
    if (props.isUploadEnabled) {
      return null;
    }

    // If document specific and no missing document
    if (props.document.type?.category === DOCUMENT_CATEGORY.SPECIFIC && props.document.state === DOCUMENT_STATUS.MISSING) {
      return 'request.documents.upload.tooltipDisabled.signatureProcessStartedAndNotFinished';
    }
    return 'request.documents.upload.tooltipDisabled.signatureProcessStarted';
  };
  const getDisabledUpdateReason = () => {
    // If document standard and upload not enabled by default
    if (!props.isUploadEnabled && props.document.type?.category !== DOCUMENT_CATEGORY.SPECIFIC && props.document.type?.category !== DOCUMENT_CATEGORY.CUSTOM) {
      return 'request.documents.upload.tooltipDisabled.signatureProcessStarted';
    }

    // If document specific and rfa is in progress
    if (props.document.isUploaded && props.rfaStatus === RFA_STATUS.READY) {
      return 'request.documents.updateTooltipDisabled';
    }
    return null;
  };
  React.useEffect(() => {
    setDisabledUploadReason(getDisabledUploadReason());
    setDisabledUpdateReason(getDisabledUpdateReason());
  }, [props.isUploadEnabled, props.rfaStatus, props.document.type, props.document.state]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(DocumentView, {
      document: props.document,
      fromOfa: props.fromOfa,
      rfaStatus: props.rfaStatus,
      onUploadClick: handleUploadDocument,
      onDownloadClick: handleDownloadDocument,
      displayUpload: props.isUploadVisible,
      disabledUploadReason: disabledUploadReason,
      disabledUpdateReason: disabledUpdateReason
    }), isPanelOpen && /*#__PURE__*/_jsx(SidePanel, {
      setCloseTrigger: closeFunction => {
        triggerClosePanel = closeFunction;
      },
      big: true,
      onClose: () => setIsPanelOpen(false),
      children: /*#__PURE__*/_jsx(UploadPanel, {
        document: props.document,
        onSubmit: handleDocumentUploaded,
        onClose: () => triggerClosePanel(),
        requestId: props.requestId
      })
    })]
  });
};
DocumentContainer.defaultProps = {
  onDocumentUpload: () => {},
  fromOfa: false,
  isUploadVisible: true,
  isUploadEnabled: true
};
DocumentContainer.propTypes = {
  document: PropTypes.object.isRequired,
  fromOfa: PropTypes.bool,
  requestId: PropTypes.number.isRequired,
  rfaStatus: PropTypes.string,
  isUploadVisible: PropTypes.bool,
  isUploadEnabled: PropTypes.bool,
  onDocumentUpload: PropTypes.func
};
export default DocumentContainer;